import { z } from 'zod';

export const feedbackTypeSchema = z.object({
  id: z.coerce.number(),
  name: z.string(),
  code: z.string(),
  description: z.string().nullable(),
  isActive: z.boolean(),
  createdAt: z.coerce.date(),
});

export const feedbackTypeListSchema = z.array(feedbackTypeSchema);

export type FeedbackType = z.infer<typeof feedbackTypeSchema>;

export const feedbackTypeFormSchema = z.object({
  code: z.string().trim().min(1, 'Code is required').max(50, 'Code must be 50 characters or fewer'),
  name: z
    .string()
    .trim()
    .min(1, 'Name is required')
    .max(100, 'Name must be 100 characters or fewer'),
  description: z.string().trim().max(500, 'Description must be 500 characters or fewer'),
  isActive: z.boolean(),
});

export type FeedbackTypeFormValues = z.infer<typeof feedbackTypeFormSchema>;

export interface CreateFeedbackTypePayload {
  name: string;
  code: string;
  description?: string;
  isActive?: boolean;
}

export type UpdateFeedbackTypePayload = Partial<CreateFeedbackTypePayload>;
